if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

(() => {
  if (window.taahysProductExperience) return;
  window.taahysProductExperience = true;
  const dialog = document.createElement('dialog');
  dialog.className = 'tpv';
  dialog.setAttribute('aria-label', 'Vue agrandie du produit');
  dialog.innerHTML = `<div class="tpv-toolbar"><span data-tpv-count></span><div class="tpv-tools"><button type="button" data-tpv-minus aria-label="Réduire le zoom">−</button><label>Zoom <input type="range" min="100" max="400" step="10" value="100" aria-label="Niveau de zoom"></label><output>100 %</output><button type="button" data-tpv-plus aria-label="Augmenter le zoom">+</button><button type="button" data-tpv-reset>Réinitialiser</button></div><button type="button" data-tpv-close aria-label="Fermer l’image">×</button></div><div class="tpv-stage"><img alt="" draggable="false"></div><button type="button" class="tpv-prev" aria-label="Photo précédente">‹</button><button type="button" class="tpv-next" aria-label="Photo suivante">›</button><p class="tpv-hint">+/− pour zoomer · faites glisser pour explorer · Échap pour fermer</p>`;
  let entries = [], index = 0, scale = 1, x = 0, y = 0, trigger, previousFocus;
  const stage = dialog.querySelector('.tpv-stage'), image = stage.querySelector('img'), range = dialog.querySelector('input'), output = dialog.querySelector('output'), pointers = new Map();
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const paint = () => {
    const maxX = Math.max(0, (image.offsetWidth * scale - stage.clientWidth) / 2);
    const maxY = Math.max(0, (image.offsetHeight * scale - stage.clientHeight) / 2);
    x = clamp(x, -maxX, maxX); y = clamp(y, -maxY, maxY);
    image.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
    range.value = Math.round(scale * 100); output.value = `${Math.round(scale * 100)} %`;
    stage.classList.toggle('is-zoomed', scale > 1);
    dialog.querySelector('[data-tpv-minus]').disabled = scale <= 1;
    dialog.querySelector('[data-tpv-plus]').disabled = scale >= 4;
  };
  const zoom = value => { scale = clamp(value, 1, 4); if (scale === 1) x = y = 0; paint(); };
  const show = value => {
    index = (value + entries.length) % entries.length;
    scale = 1; x = y = 0; pointers.clear();
    image.src = entries[index].src; image.alt = entries[index].alt || 'Taahys product';
    dialog.querySelector('[data-tpv-count]').textContent = `${index + 1} / ${entries.length}`;
    dialog.querySelector('.tpv-prev').hidden = dialog.querySelector('.tpv-next').hidden = entries.length < 2;
    paint();
  };
  const open = (items, selected, source) => {
    if (!dialog.isConnected) document.body.append(dialog);
    entries = items; trigger = source; previousFocus = document.activeElement;
    show(selected); document.documentElement.classList.add('tpv-open'); dialog.showModal();
  };
  image.addEventListener('load', paint);
  range.addEventListener('input', () => zoom(Number(range.value) / 100));
  dialog.querySelector('[data-tpv-minus]').addEventListener('click', () => zoom(scale - .25));
  dialog.querySelector('[data-tpv-plus]').addEventListener('click', () => zoom(scale + .25));
  dialog.querySelector('[data-tpv-reset]').addEventListener('click', () => zoom(1));
  dialog.querySelector('[data-tpv-close]').addEventListener('click', () => dialog.close());
  dialog.querySelector('.tpv-prev').addEventListener('click', () => show(index - 1));
  dialog.querySelector('.tpv-next').addEventListener('click', () => show(index + 1));
  dialog.addEventListener('close', () => { document.documentElement.classList.remove('tpv-open'); pointers.clear(); (trigger || previousFocus)?.focus({preventScroll:true}); });
  dialog.addEventListener('keydown', e => {
    if (e.target === range) return;
    if (e.key === '+' || e.key === '=') { e.preventDefault(); zoom(scale + .25); }
    if (e.key === '-') { e.preventDefault(); zoom(scale - .25); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
  });
  stage.addEventListener('wheel', e => { e.preventDefault(); zoom(scale * (e.deltaY < 0 ? 1.12 : 1 / 1.12)); }, {passive:false});
  stage.addEventListener('dblclick', () => zoom(scale > 1 ? 1 : 2));
  stage.addEventListener('pointerdown', e => { stage.setPointerCapture(e.pointerId); pointers.set(e.pointerId, {x:e.clientX,y:e.clientY}); });
  stage.addEventListener('pointermove', e => {
    if (!pointers.has(e.pointerId)) return;
    const old = pointers.get(e.pointerId), next = {x:e.clientX,y:e.clientY};
    if (pointers.size === 2) {
      const other = [...pointers.entries()].find(([id]) => id !== e.pointerId)[1];
      const before = Math.hypot(old.x-other.x,old.y-other.y), after = Math.hypot(next.x-other.x,next.y-other.y);
      if (before > 0) scale = clamp(scale * after / before, 1, 4);
    } else if (scale > 1) { x += next.x-old.x; y += next.y-old.y; }
    pointers.set(e.pointerId,next); paint();
  });
  ['pointerup','pointercancel','lostpointercapture'].forEach(name => stage.addEventListener(name,e => pointers.delete(e.pointerId)));
  window.addEventListener('resize', () => { if(dialog.open) paint(); });
  document.addEventListener('click', e => {
    const photo = e.target.closest('.te-photo');
    if (photo) {
      const root = photo.closest('.te'), photos = [...root.querySelectorAll('.te-photo:not([hidden])')], data = JSON.parse(root.querySelector('[data-gallery-data]').textContent);
      const items = photos.map(p => { const full = data.find(i=>i.group===p.dataset.group&&i.view===p.dataset.view); return {src:full?.src||p.querySelector('img').src,alt:p.querySelector('img').alt}; });
      e.preventDefault(); e.stopImmediatePropagation(); open(items,photos.indexOf(photo),photo); return;
    }
    const toggle = e.target.closest('product-info .product__media-toggle');
    if (toggle) {
      const root = toggle.closest('product-info'), photos = [...root.querySelectorAll('.product__media-list .product__modal-opener--image')].filter(p=>p.offsetParent!==null);
      const selected = toggle.closest('.product__modal-opener--image');
      const items = photos.map(p => {
        const id = p.querySelector('[data-media-id]')?.dataset.mediaId || p.closest('[data-media-id]')?.dataset.mediaId;
        const modal = [...root.querySelectorAll('product-modal [data-media-id]')].find(m=>m.dataset.mediaId===id);
        const img = modal?.matches('img') ? modal : modal?.querySelector('img');
        const fallback = p.querySelector('img');
        return {src:img?.src||fallback.src,alt:fallback.alt};
      });
      if(items.length) { e.preventDefault(); e.stopImmediatePropagation(); open(items,Math.max(0,photos.indexOf(selected)),toggle); }
    }
    const step = e.target.closest('[data-te-step]');
    if(step) { const input=step.parentElement.querySelector('input'); step.dataset.teStep==='minus'?input.stepDown():input.stepUp(); input.dispatchEvent(new Event('change',{bubbles:true})); }
  }, true);
  const enhance = () => {
    document.querySelectorAll('product-info .product__info-container').forEach(root => {
      if(root.dataset.taahysBuy) return; root.dataset.taahysBuy='true';
      const title=root.querySelector('.product__title h1');
      if(title?.textContent.includes(' — ')) {
        title.textContent = title.textContent.trim();
      }
      const picker=root.querySelector('variant-selects'); if(picker) root.prepend(picker);
      const quantity=root.querySelector('.product-form__quantity'), buy=root.querySelector('product-form');
      if(quantity && buy) {
        const note=document.createElement('p'); note.className='taahys-shipping'; note.textContent='Livraison offerte · réception sous 6–10 jours ouvrés au total';
        quantity.before(note); if(buy.previousElementSibling!==quantity) quantity.after(buy);
      }
      const description=root.querySelector('.product__description');
      if(description) {
        const general=document.createElement('div'), measures=document.createElement('div'), details=document.createElement('div'), list=document.createElement('ul');
        let target=general;
        [...description.childNodes].forEach(node=>{if(node.nodeType===1&&/^H[2-6]$/.test(node.tagName)&&/Entretien|Livraison|retours/i.test(node.textContent))target=details;target.append(node)});
        general.querySelectorAll('li').forEach(li=>{if(/Hauteur|Diamètre|Dimensions|Largeur|Profondeur/i.test(li.textContent))list.append(li)});
        const heading=document.createElement('h2');heading.textContent='Product dimensions';measures.append(heading,list); description.replaceChildren(); makeTabs(description,[['Description',general],['Mesures',measures],['Détails',details]]);
      }
    });
    document.querySelectorAll('.te').forEach(root => {
      const form=root.querySelector('.te-form'); if(!form || root.dataset.taahysBuy) return; root.dataset.taahysBuy='true';
      const color=[...form.querySelectorAll('.te-options')].find(f=>f.querySelector('legend')?.textContent.includes('Couleur'));
      if(color) root.querySelector('.te-buy').prepend(color);
      const status=root.querySelector('.te-status'); if(status) root.querySelector('.te-action-row').before(status);
      const source=root.querySelector('.te-details');
      if(source){const items=[...source.querySelectorAll('details')],description=items[1]?.querySelector('.te-detail-body'),measures=items[0]?.querySelector('.te-detail-body'),details=document.createElement('div');items.slice(2).forEach(d=>{const h=document.createElement('h2');h.textContent=d.querySelector('summary').textContent.replace('+','').trim();details.append(h,d.querySelector('.te-detail-body'))});if(description&&measures){source.replaceChildren();makeTabs(source,[['Description',description],['Mesures',measures],['Détails',details]])}}
    });
  };
  let tabSequence=0;
  const makeTabs=(host,items)=>{
    host.classList.add('taahys-tabs');const nav=document.createElement('div');nav.className='taahys-tablist';nav.setAttribute('role','tablist');nav.setAttribute('aria-label','Informations produit');host.append(nav);
    const buttons=[],panels=[];const select=i=>{buttons.forEach((b,n)=>{b.setAttribute('aria-selected',String(n===i));b.tabIndex=n===i?0:-1;panels[n].hidden=n!==i})};
    items.forEach(([label,content],i)=>{const id=`taahys-tab-${++tabSequence}`,button=document.createElement('button'),panel=document.createElement('div');button.type='button';button.id=id;button.textContent=label;button.setAttribute('role','tab');button.setAttribute('aria-controls',id+'-panel');panel.id=id+'-panel';panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',id);panel.tabIndex=0;panel.append(content);buttons.push(button);panels.push(panel);nav.append(button);host.append(panel);button.addEventListener('click',()=>select(i));button.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%items.length;else if(e.key==='ArrowLeft')n=(i+items.length-1)%items.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=items.length-1;else return;e.preventDefault();select(n);buttons[n].focus()})});select(0);
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',enhance); else enhance();
  document.addEventListener('shopify:section:load',enhance);
})();


(() => {
  const init = () => {
    document.querySelectorAll('.te-gallery-wrap, product-info media-gallery').forEach(wrap => {
      if(wrap.dataset.taahysDots)return;wrap.dataset.taahysDots='true';
      const gallery=wrap.querySelector('.te-gallery, .product__media-list');if(!gallery)return;
      const nav=document.createElement('div');nav.className='taahys-gallery-dots';nav.setAttribute('role','group');nav.setAttribute('aria-label','Choisir une image');wrap.append(nav);
      const photos=()=>[...gallery.querySelectorAll('.te-photo:not([hidden]), .product__media-item')].filter(p=>!p.hidden&&getComputedStyle(p).display!=='none');
      const active=()=>{const items=photos();if(!items.length)return;const origin=gallery.getBoundingClientRect().left;let closest=0,distance=Infinity;items.forEach((p,i)=>{const d=Math.abs(p.getBoundingClientRect().left-origin);if(d<distance){distance=d;closest=i}});[...nav.children].forEach((b,i)=>{b.setAttribute('aria-current',i===closest?'true':'false');b.classList.toggle('is-active',i===closest)})};
      const build=()=>{const items=photos();nav.replaceChildren();nav.hidden=items.length<2;items.forEach((p,i)=>{const b=document.createElement('button');b.type='button';b.setAttribute('aria-label',`Afficher l’image ${i+1} sur ${items.length}`);b.addEventListener('click',()=>gallery.scrollTo({left:p.getBoundingClientRect().left-gallery.getBoundingClientRect().left+gallery.scrollLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));nav.append(b)});active()};
      gallery.addEventListener('scroll',active,{passive:true});wrap.closest('.te,product-info')?.addEventListener('change',build);window.addEventListener('resize',active);build();
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

